<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="80"
      card
      color="#fff"
    >
      <v-layout row align-center justify-space-between>
        <v-flex grow>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-flex',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <img
              style="margin-left: 3px"
              :src="require('@/assets/icons/autorizar.svg')"
            />
          </div>
          <h1 style="display: inline">Pases de salida</h1>
        </v-flex>
      </v-layout>
      <template v-slot:extension>
        <v-speed-dial
          v-if="currentTab === 0"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <router-link
                v-if="isAuhotizationEnabled"
                slot="activator"
                :to="{ name: 'createAuthorizations' }"
              >
                <v-btn style="z-index: 99" color="gradiente" dark small fab>
                  <v-icon style="width: 100%">add</v-icon>
                </v-btn>
              </router-link>
              <v-btn
                v-else
                slot="activator"
                style="z-index: 99"
                color="gradiente"
                dark
                small
                fab
                @click="showRedirect"
              >
                <v-icon style="width: 100%">add</v-icon>
              </v-btn>
              <span>Crear nuevo pase de salida</span>
            </v-tooltip>
          </template>
        </v-speed-dial>
        <v-tabs
          v-model="currentTab"
          color="transparent"
          style="margin-left: 70px"
        >
          <v-tab v-for="tab in tabs" :key="tab.id">
            <span class="text-uppercase">{{ tab.name }}</span>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-tabs-items v-model="currentTab">
      <v-tab-item>
        <v-container
          fluid
          grid-list-xl
          style="
            padding: 20px;
            height: 90vh;
            overflow: scroll;
            padding-bottom: 180px !important;
          "
        >
          <v-layout row wrap>
            <v-flex xs12 style="padding: 0 12px 10px">
              <v-card flat class="border-container">
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm4 md3>
                      <v-menu
                        :close-on-content-click="false"
                        :nudge-left="500"
                        :nudge-width="500"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        max-width="600px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            label="Buscar"
                            class="border-container"
                            prepend-inner-icon="search"
                            clearable
                            solo
                            flat
                            hide-details
                            v-model="collegeFilters.search"
                            @keyup.enter="getCollegeAuthorizations"
                            @click:clear="collegeClearSearch"
                          >
                            <template v-slot:append>
                              <v-icon v-on="on">tune</v-icon>
                            </template>
                          </v-text-field>
                        </template>
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <!-- initial date -->
                              <v-flex xd12 sm12 md12 pa-1>
                                <div class="border-container px-3">
                                  <v-layout row wrap align-center>
                                    <v-flex xs5 sm4 pr-0>
                                      Fecha de inicio
                                    </v-flex>
                                    <v-flex xs7 sm8 pl-0 ml>
                                      <v-menu
                                        :close-on-content-click="true"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                      >
                                        <template
                                          late
                                          v-slot:activator="{ on }"
                                        >
                                          <v-text-field
                                            id="first-small"
                                            :value="
                                              parseTimeFromTimePicker(
                                                collegeFilters.startDate
                                              )
                                            "
                                            label="Fecha de inicio"
                                            prepend-icon="event"
                                            readonly
                                            solo
                                            flat
                                            hide-details
                                            v-on="on"
                                            class="padded"
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker
                                          header-color="primary"
                                          color="secondary"
                                          locale="es-419"
                                          scrollable
                                          :min="dateLimitToday"
                                          :max="collegeFilters.endDate"
                                          v-model="collegeFilters.startDate"
                                        ></v-date-picker>
                                      </v-menu>
                                    </v-flex>
                                  </v-layout>
                                </div>
                              </v-flex>
                              <!-- final date -->
                              <v-flex xd12 sm12 md12 pa-1>
                                <div class="border-container px-3">
                                  <v-layout row wrap align-center>
                                    <v-flex xs5 sm4 pr-0>
                                      Fecha de término
                                    </v-flex>
                                    <v-flex xs7 sm8 pl-0>
                                      <v-menu
                                        :close-on-content-click="true"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                      >
                                        <template v-slot:activator="{ on }">
                                          <v-text-field
                                            id="last-small"
                                            :value="
                                              parseTimeFromTimePicker(
                                                collegeFilters.endDate
                                              )
                                            "
                                            label="Fecha de término"
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                            solo
                                            flat
                                            hide-details
                                            class="padded"
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker
                                          header-color="primary"
                                          color="secondary"
                                          locale="es-419"
                                          scrollable
                                          :min="collegeFilters.startDate"
                                          v-model="collegeFilters.endDate"
                                        ></v-date-picker>
                                      </v-menu>
                                    </v-flex>
                                  </v-layout>
                                </div>
                              </v-flex>

                              <!-- STATUS -->
                              <v-flex xd12 sm12 md12 pa-1>
                                <div class="border-container px-3">
                                  <v-select
                                    flat
                                    solo
                                    hide-details
                                    clearable
                                    :items="possibleStatus"
                                    item-text="text"
                                    item-value="value"
                                    v-model="collegeFilters.status"
                                    label="Estatus"
                                    multiple
                                    @change="getCollegeAuthorizations"
                                  >
                                    <template
                                      v-slot:selection="{ item, index }"
                                      v-if="
                                        possibleStatus.length ===
                                        collegeFilters.status.length
                                      "
                                    >
                                      <span
                                        v-if="
                                          possibleStatus.length ===
                                            collegeFilters.status.length &&
                                          index === possibleStatus.length - 1
                                        "
                                      >
                                        Todos
                                      </span>
                                    </template>
                                    <template v-slot:prepend-item>
                                      <v-list-tile ripple @click="toggle">
                                        <v-list-tile-action>
                                          <v-icon
                                            :color="
                                              collegeFilters.status.length > 0
                                                ? 'red'
                                                : ''
                                            "
                                          >
                                            {{ icon }}
                                          </v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                          <v-list-tile-title>
                                            Todos
                                          </v-list-tile-title>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                      <v-divider class="mt-2"></v-divider>
                                    </template>
                                  </v-select>
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                          <v-card-actions
                            style="justify-content: end; margin-right: 8px"
                          >
                            <v-flex
                              xd12
                              sm7
                              md4
                              style="display: flex; justify-content: end"
                            >
                              <v-btn
                                @click="collegeFilterClear"
                                v-show="collegeShowFilter"
                                color="primary"
                              >
                                <v-icon left>close</v-icon>
                                Limpiar filtros
                              </v-btn>
                            </v-flex>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 style="padding: 0 12px 10px">
              <v-card flat class="border-container">
                <v-card-text class="px-0 py-0">
                  <v-data-table
                    :rows-per-page-items="[25, 50, 100]"
                    rows-per-page-text="Registros por página"
                    :headers="collegueHeaders"
                    :items="collegeItems"
                    :total-items="collegeTotalItems"
                    :loading="isLoadingCollegueTable"
                    :pagination.sync="colleguePagination"
                    @update:pagination="getCollegeAuthorizations"
                    no-results-text="No se encontraron coincidencias"
                    no-data-text="No hay registros"
                    must-sort
                  >
                    <template v-slot:headers="props">
                      <tr>
                        <td
                          v-for="header in props.headers"
                          :style="header.style"
                        >
                          {{ header.text }}
                        </td>
                      </tr>
                    </template>
                    <template v-slot:items="props">
                      <tr class="body-2 font-weight-regular">
                        <td>{{ props.item.name }}</td>
                        <td class="font-weight-medium">
                          <span
                            v-if="props.item.status === 'FINALIZED'"
                            class="red--text"
                          >
                            Expirado
                          </span>
                          <span
                            v-else-if="props.item.status === 'NEAR'"
                            class="orange--text"
                          >
                            Próximo
                          </span>
                          <span v-else class="green--text"> Vigente </span>
                        </td>
                        <td>
                          {{ timeUi(props.item.type, props.item, 'start') }}
                        </td>
                        <td>
                          {{ timeUi(props.item.type, props.item, 'end') }}
                        </td>
                        <td>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn @click="detail(props.item)" icon v-on="on">
                                <v-icon class="gray--text">visibility</v-icon>
                              </v-btn>
                            </template>
                            <span>Ver detalle</span>
                          </v-tooltip>
                        </td>
                        <td>
                          <DropDownOptions>
                            <v-list>
                              <v-list-tile
                                @click="
                                  !isAuhotizationEnabled
                                    ? showRedirect()
                                    : editAuthorization(props.item.id)
                                "
                              >
                                <v-list-tile-action>
                                  <v-icon>edit</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    Editar
                                  </v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                              <v-divider></v-divider>
                              <v-list-tile
                                @click="deletAuthorization(props.item.id)"
                              >
                                <v-list-tile-action>
                                  <v-icon>delete</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    Eliminar
                                  </v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-list>
                          </DropDownOptions>
                        </td>
                      </tr>
                    </template>
                    <v-progress-linear
                      v-slot:progress
                      color="primary"
                      indeterminate
                    ></v-progress-linear>
                    <template v-slot:no-data>
                      <div>No hay registros para filtrar</div>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container
          fluid
          grid-list-xl
          style="
            padding: 20px;
            height: 90vh;
            overflow: scroll;
            padding-bottom: 180px !important;
          "
        >
          <v-layout row wrap>
            <v-flex xs12 style="padding: 0 12px 10px">
              <v-card flat class="border-container">
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm4 md3>
                      <v-menu
                        :close-on-content-click="false"
                        :nudge-left="500"
                        :nudge-width="500"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        max-width="600px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            label="Buscar"
                            class="border-container"
                            prepend-inner-icon="search"
                            clearable
                            solo
                            flat
                            hide-details
                            v-model="filters.search"
                            @keyup.enter="getAuthorizations"
                            @click:clear="clearSearch"
                          >
                            <template v-slot:append>
                              <v-icon v-on="on">tune</v-icon>
                            </template>
                          </v-text-field>
                        </template>
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <!-- Level -->
                              <v-flex xs12 sm6 md6 pa-1>
                                <v-layout row>
                                  <v-flex pr-1>
                                    <div class="icon-select border-container">
                                      <v-icon color="primary" medium>
                                        person
                                      </v-icon>
                                    </div>
                                  </v-flex>
                                  <v-flex pl-1>
                                    <v-select
                                      multiple
                                      class="border-container"
                                      :items="levels"
                                      v-model="filters.levelIds"
                                      item-text="levelName"
                                      item-value="levelId"
                                      label="Nivel"
                                      flat
                                      solo
                                      hide-details
                                      no-data-text="No hay registros para filtrar"
                                      @change="filterLevel"
                                    />
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <!-- Group -->
                              <v-flex xs12 sm6 md6 pa-1>
                                <v-layout row>
                                  <v-flex pr-1>
                                    <div class="icon-select border-container">
                                      <v-icon color="primary" medium
                                        >person</v-icon
                                      >
                                    </div>
                                  </v-flex>
                                  <v-flex pl-1>
                                    <v-select
                                      multiple
                                      class="border-container"
                                      :items="grades"
                                      v-model="filters.gradeGroupIds"
                                      item-text="groupName"
                                      label="Grupo"
                                      item-value="groupId"
                                      flat
                                      solo
                                      hide-details
                                      no-data-text="No hay registros para filtrar"
                                      @change="getAuthorizations"
                                    />
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                          <v-card-actions
                            style="justify-content: end; margin-right: 8px"
                          >
                            <v-flex
                              xd12
                              sm7
                              md4
                              style="display: flex; justify-content: end"
                            >
                              <v-btn
                                @click="filterClear"
                                v-show="showFilter"
                                color="primary"
                              >
                                <v-icon left>close</v-icon>
                                Limpiar filtros
                              </v-btn>
                            </v-flex>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 style="padding: 0 12px 10px">
              <v-card flat class="border-container">
                <v-card-text class="px-0 py-0">
                  <v-data-table
                    :rows-per-page-items="[25, 50, 100]"
                    rows-per-page-text="Registros por página"
                    :headers="headers"
                    :items="items"
                    :total-items="totalItems"
                    :loading="isLoadingTable"
                    :pagination.sync="pagination"
                    @update:pagination="getAuthorizations"
                    no-results-text="No se encontraron coincidencias"
                    no-data-text="No hay registros"
                    must-sort
                  >
                    <template v-slot:headers="props">
                      <tr>
                        <td
                          v-for="header in props.headers"
                          :style="header.style"
                        >
                          {{ header.text }}
                        </td>
                      </tr>
                    </template>
                    <template v-slot:items="props">
                      <tr>
                        <td style="width: 70px">
                          <span>
                            <v-icon
                              v-if="
                                props.item.imageStorage == undefined ||
                                props.item.imageStorage.miniObjUrl == undefined
                              "
                            >
                              account_circle
                            </v-icon>
                            <v-avatar v-else size="30" color="grey lighten-4">
                              <img :src="props.item.imageStorage.miniObjUrl" />
                            </v-avatar>
                          </span>
                        </td>
                        <td>{{ props.item.firstName }}</td>
                        <td>{{ props.item.lastName }}</td>
                        <td>{{ props.item.level }}</td>
                        <td>{{ props.item.grade }}{{ props.item.group }}</td>
                        <td>{{ props.item.parentFirstName }}</td>
                        <td>{{ props.item.parentLastName }}</td>
                        <td>
                          {{ timeUi(props.item.type, props.item) }}
                        </td>
                      </tr>
                    </template>
                    <v-progress-linear
                      v-slot:progress
                      color="primary"
                      indeterminate
                    ></v-progress-linear>
                    <template v-slot:no-data>
                      <div>No hay registros para filtrar</div>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
    <ConfirmRedirect
      :show="modals.showRedirect"
      title="Error al crear pase de salida"
      :description="'No es posible crear pases de salida, debido a que se encuentra deshabilitada esta opción en la sección de Configuración. \n\n¿Quieres habilitarlo?'"
      @change="onConfirmRedirect"
      ok-text="Si, ir a habilitarlo"
      cancel-text="No, Cancelar"
    />
    <ConfirmDelete
      :show="modals.showDelete"
      title="Eliminar pase de salida"
      cancel-text="No, Cancelar"
      ok-text="Sí, Eliminar"
      @change="onConfirmDelete"
    >
      <p>
        Al eliminar este pase de salida, todos los alumnos que estaban
        autorizados, deberán contar con una solicitud del tutor para poder hacer
        check out.
        <br />
        <br />
        ¿Deseas eliminarlo?
      </p>
    </ConfirmDelete>
    <ResponseDialog
      v-model="modals.deleteResponseShow"
      :loading="modals.deleteResponseLoading"
      :is-error="modals.deleteResponseIsError"
      :message="modals.deleteResponseMessage"
      :auto-close="true"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { _isSomeDifferent } from '../../../../utils/genericUtils.js'
import {
  default as ConfirmDelete,
  default as ConfirmRedirect,
} from '../../../Dialogs/confirm_new_ui.vue'
import DropDownOptions from '../../../dropDown/options.vue'
import { filterByLevel, parseGroups, parseLevels } from '../Registers/utils.js'
import ResponseDialog from './responseDialog.vue'

export default {
  components: {
    DropDownOptions,
    ConfirmDelete,
    ConfirmRedirect,
    ResponseDialog,
  },
  data() {
    return {
      isAuhotizationEnabled: false,
      currentTab: 0,
      tabs: [
        { id: 1, name: 'autorizados por colegio' },
        { id: 2, name: 'autorizados por tutores' },
      ],
      showFilter: false,
      collegeShowFilter: false,
      filters: {
        search: '',
        levelIds: [],
        gradeGroupIds: [],
      },
      collegeFilters: {
        search: '',
        startDate: '',
        endDate: '',
        status: ['ACTIVE', 'NEAR', 'FINALIZED'],
      },
      possibleStatus: [
        { text: 'Activo', value: 'ACTIVE' },
        { text: 'Próximos', value: 'NEAR' },
        { text: 'Finalizado', value: 'FINALIZED' },
      ],
      totalItems: 0,
      collegeTotalItems: 0,
      headers: [
        {
          text: 'Foto',
          value: 'AVATAR',
          sortable: false,
          align: 'center',
          style: 'width: 70px;',
        },
        {
          text: 'Nombre alumno',
          value: 'STUDENT_NAME',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Apellido alumno',
          value: 'STUDENT_LAST_NAME',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Nivel',
          value: 'LEVEL',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Grupo',
          value: 'GROUP',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Nombre tutor',
          value: 'TUTOR_NAME',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Apellido tutor',
          value: 'TUTOR_LAST_NAME',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Vigencia',
          value: 'EXPIRATION',
          sortable: false,
          align: 'center',
        },
      ],
      collegueHeaders: [
        {
          text: 'Nombre',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Estatus',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Fecha de inicio',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Fecha de fin',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Detalle',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Acción',
          sortable: false,
          align: 'center',
        },
      ],
      items: [],
      collegeItems: [],
      posibleFilters: {
        levels: [],
        gradeGroups: [],
      },
      isLoadingTable: false,
      isLoadingCollegueTable: false,
      levels: [],
      grades: [],
      colleguePagination: {
        page: 1,
        rowsPerPage: 25,
      },
      pagination: {
        page: 1,
        rowsPerPage: 25,
      },
      initialStateParams: undefined,
      collegeInitialStateParams: undefined,
      dateLimitToday: '',
      modals: {
        showRedirect: false,
        showDelete: false,
        deleteResponseShow: false,
        deleteResponseLoading: false,
        deleteResponseMessage: false,
        deleteResponseIsError: false,
        deleteId: undefined,
      },
    }
  },
  beforeMount() {
    this.getAuthorizations(true)
    this.getCollegeAuthorizations(true)
  },
  mounted() {
    this._setupLevels()
    this.dateLimitToday = new Date().toLocaleDateString('sv-SE')
    this.checkIsAuhotizationEnabled()
  },
  methods: {
    _timeParseCapitalize(time = '') {
      const [day, month, year] = time.split('/')
      const capitalMonth = `${month
        .substring(0, 1)
        .toUpperCase()}${month.substring(1)}`

      return `${day}/${capitalMonth}/${year}`
    },
    /**
     *
     * @param {'RANGE'|'ONLY_ONCE'} type
     * @param {'start'|'end'|'both'} onRangeGetDates
     */
    timeUi(type, item, onRangeGetDates = 'both') {
      if (type === undefined) return '-'
      if (this.getBrandTZ.timezone === undefined) return '-'

      if (type === 'ONLY_ONCE') {
        return this._timeParseCapitalize(this._parseTime(item.date))
      }

      if (type !== 'RANGE') return '-'

      const startDay = this._timeParseCapitalize(
        this._parseTime(item.startDate)
      )
      const endDay = this._timeParseCapitalize(this._parseTime(item.endDate))

      const dates = [startDay, endDay]

      if (onRangeGetDates === 'end') {
        return endDay
      }

      if (onRangeGetDates === 'start') {
        return startDay
      }

      return dates.join(' al ')
    },
    /**
     * Return a date like so `24/Jul/2023 `
     */
    _parseTime(date) {
      return moment(new Date(date)).format('DD/MMM/YYYY').replaceAll('.', '')
      // .tz(this.getBrandTZ.timezone)
    },
    /**
     * accept a string like so `"2023-11-01"`
     */
    parseTimeFromTimePicker(date = '') {
      if (date === '') return ''

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    async _setupLevels() {
      const { data } = await this.$store.dispatch('student/getStudentsFilters')

      const levels = parseLevels({ levels: data })
      const groups = parseGroups({ gradeGroups: data })
      this.levels = levels
      this.grades = groups
      this.posibleFilters = { ...this.posibleFilters, levels: levels }
      this.posibleFilters = { ...this.posibleFilters, gradeGroups: groups }
    },
    _resetLevels() {
      this.levels = this.posibleFilters.levels
      this.filters.levelIds = []
    },
    _resetGrades() {
      this.grades = this.posibleFilters.gradeGroups
      this.filters.gradeGroupIds = []
    },
    async filterLevel() {
      if (this.filters.levelIds.length === 0) {
        this._resetGrades()
        this._resetLevels()
        this.getAuthorizations()
        return
      }

      const groups = filterByLevel({
        levelIds: this.filters.levelIds,
        posibleGroups: this.posibleFilters.gradeGroups,
      })
      this.grades = groups
      this.getAuthorizations()
    },
    async getAuthorizations(isInitialStateParams = false) {
      const params = {
        size: this.pagination.rowsPerPage,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        search: this.filters.search === '' ? undefined : this.filters.search,
        levelIds: this.filters.levelIds,
        gradeGroupIds: this.filters.gradeGroupIds,
      }

      if (isInitialStateParams === true) {
        const tempObj = structuredClone(params)
        const tempParams = Object.keys(tempObj)
          .filter((e) => tempObj[e] !== undefined)
          .map((e) => `${e}_${tempObj[e]}`)
        this.initialStateParams = tempParams
        return
      }

      const tempObj = structuredClone(params)
      const tempParams = Object.keys(params)
        .filter((e) => tempObj[e] !== undefined)
        .map((e) => `${e}_${tempObj[e]}`)

      this.showFilter = _isSomeDifferent(
        structuredClone(this.initialStateParams),
        tempParams
      )

      this.isLoadingTable = true
      try {
        const response = await this.$store.dispatch(
          'authorizations/getStudentAuthorizations',
          params
        )
        this.items = response.data.data
        this.totalItems = response.data.total
      } catch (error) {
        console.log(error)
        this.items = []
        this.totalItems = 0
      } finally {
        this.isLoadingTable = false
      }
    },
    _filterDiff(params) {
      const tempObj = structuredClone(params)
      const tempParams = Object.keys(params)
        .filter((e) => tempObj[e] !== undefined)
        .map((e) => `${e}_${tempObj[e]}`)
      return tempParams
    },
    async getCollegeAuthorizations(isInitialStateParams = false) {
      const params = {
        search:
          this.collegeFilters.search === ''
            ? undefined
            : this.collegeFilters.search,
        from:
          this.collegeFilters.startDate !== ''
            ? this.collegeFilters.startDate
            : undefined,
        to:
          this.collegeFilters.endDate !== ''
            ? this.collegeFilters.endDate
            : undefined,
        status:
          this.collegeFilters.status.length === this.possibleStatus.length
            ? undefined
            : this.collegeFilters.status,
      }

      if (isInitialStateParams === true) {
        this.collegeInitialStateParams = this._filterDiff(params)
        return
      }

      this.collegeShowFilter = _isSomeDifferent(
        structuredClone(this.collegeInitialStateParams),
        this._filterDiff(params)
      )

      this.isLoadingCollegueTable = true
      try {
        const response = await this.$store.dispatch(
          'authorizations/getCollegeAuthorizations',
          params
        )
        this.collegeItems = response.data.data
        this.collegeTotalItems = response.data.total
      } catch (error) {
        console.log(error)
        this.collegeItems = []
        this.collegeTotalItems = 0
      } finally {
        this.isLoadingCollegueTable = false
      }
    },
    collegeClearSearch() {
      this.collegeFilters.search = ''
      this.getCollegeAuthorizations()
    },
    clearSearch() {
      this.filters.search = ''
      this.getAuthorizations()
    },
    collegeFilterClear() {
      this.collegeFilters = {
        startDate: '',
        endDate: '',
        search: '',
        status: ['ACTIVE', 'NEAR', 'FINALIZED'],
      }
      this.colleguePagination = {
        page: 1,
        rowsPerPage: 25,
      }
      this.getCollegeAuthorizations()
    },
    filterClear() {
      this._resetGrades()
      this._resetLevels()
      this.filters.search = ''
      this.pagination.page = 1
      this.pagination.rowsPerPage = 25
      this.getAuthorizations()
    },
    deletAuthorization(id) {
      this.modals.deleteId = id
      this.modals.showDelete = true
    },
    async onConfirmDelete(e) {
      this.modals.showDelete = false
      if (e === false) return
      this.modals.deleteResponseShow = true
      this.modals.deleteResponseLoading = true
      try {
        await this.$store.dispatch(
          'authorizations/deleteAuthorization',
          this.modals.deleteId
        )
        this.modals.deleteResponseIsError = false
        this.modals.deleteResponseMessage =
          'Pase de salida eliminado con éxito.'
      } catch (error) {
        console.log(error)
        const customErrors = {
          404: 'No se encontró el permiso.',
          400: 'El permiso que se pretende eliminar no pertenece al colegio.',
        }

        this.modals.deleteResponseIsError = true
        this.modals.deleteResponseMessage = customErrors[error.response.status]
          ? customErrors[error.response.status]
          : 'Error al eliminar pase de salida'
      } finally {
        this.modals.deleteResponseLoading = false
        this.modals.deleteId = undefined
        this.getCollegeAuthorizations()
      }
    },
    editAuthorization(id) {
      this.$router.push({
        name: 'editAuthorizations',
        params: { id: id },
      })
    },
    detail(item) {
      this.$router.push({
        name: 'detailAuthorizations',
        params: { id: item.id },
      })
    },
    toggle() {
      this.$nextTick(() => {
        if (this.selectAllItems) {
          this.collegeFilters.status = []
        } else {
          this.collegeFilters.status = this.possibleStatus.slice()
        }
        this.getCollegeAuthorizations()
      })
    },
    showRedirect() {
      this.modals.showRedirect = true
    },
    onConfirmRedirect(e) {
      this.modals.showRedirect = false
      if (e === false) return
      this.$router.push({
        name: 'Configuration',
        query: {
          tab: '1',
        },
      })
    },
    checkIsAuhotizationEnabled() {
      this.isAuhotizationEnabled =
        this.getBranch.settings.find((e) => e.name === 'CHECKOUT_AUTHORIZATION')
          .value === 'YES'
    },
  },
  computed: {
    ...mapGetters(['getBrandTZ', 'getBranch']),
    selectAllItems() {
      return this.collegeFilters.status.length === this.possibleStatus.length
    },
    selectSomeItems() {
      return this.collegeFilters.status.length > 0 && !this.selectAllItems
    },
    icon() {
      if (this.selectAllItems) return 'disabled_by_default'
      if (this.selectSomeItems) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    },
  },
  watch: {
    getBranch: function () {
      if (this.getBranch === undefined) return
      this.checkIsAuhotizationEnabled()
    },
    'collegeFilters.startDate': function () {
      if (this.collegeFilters.startDate === '') return
      this.getCollegeAuthorizations()
    },
    'collegeFilters.endDate': function () {
      if (this.collegeFilters.endDate === '') return
      this.getCollegeAuthorizations()
    },
  },
}
</script>
<style scoped>
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}

.icon-select {
  padding: 8px;
}

::v-deep .v-input__prepend-outer {
  margin-right: -1px !important;
}

::v-deep .padded .v-input__slot {
  padding-left: 8px !important;
}

::v-deep .v-datatable.v-table > thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

table.v-table > thead tr {
  background-color: #dddddd;
  background-color: #f9fafb;
  height: 40px;
}
::v-deep .v-datatable.v-table > thead tr {
  background-color: #dddddd;
  text-transform: initial !important;
  color: #6b7280;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  white-space: nowrap;
}

::v-deep .v-datatable.v-table > tbody {
  max-height: 50vh;
}
::v-deep .v-datatable.v-table > tbody tr td {
  text-align: center;
  font-size: inherit;
  font-weight: inherit;
}
::v-deep .v-datatable.v-table > tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

@media (max-width: 600px) {
  ::v-deep .v-datatable.v-table > thead {
    display: block;
  }
}
</style>
